.ki{color:var(--gray-900);}